import { makeLabels } from 'utils/i18n';

const NAMESPACE = 'pages.cryptoPayout.details.outline';

const LABELS = makeLabels(
  {
    UUID: ['payoutUuid', 'Payout ID'],
    AMOUNT: ['amount', 'Payout total'],
    STATUS: ['status', 'Status'],
  },
  NAMESPACE,
);

export default LABELS;
